import { Card, Col, Form, Input, Row, Menu, Modal, message } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ChartLoader from 'components/ChartLoader';
import { useTranslation } from 'react-i18next'

const randR = () => {
  let res = [];
  let len = 100;
  while (len--) {
    res.push(0)
  }
  return res;
};

const gen2STime = () => {
  let now = new Date();
  let res = [];
  let len = 100;
  while (len--) {
    res.unshift(now.toLocaleTimeString().replace(/^\D*/, ""));
    now = new Date(+now - 2000);
  }
  return res;
};

const DeviceDebugModal = (props) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const [chartLoading, setChartLoading] = useState(true)
  const [showCustomPicker, setShowCustomPicker] = useState(false)

  const handleOption = (item) => {

    console.log("Selected option:", item.key);

    if (mode != item.key){
      setMode(item.key)
    }

    if (item.key === 'CUSTOM') {
      setShowCustomPicker(true)
      return
    }

    setShowCustomPicker(false)

    if (item.key){
      if (props.selectedDevice && props.selectedDevice.MAC){
        if (props.data){
          setChartLoading(true)
        }
        props.action(props.selectedDevice.MAC,item.key)
      }
    }else{
      if (dateRange[0] == null || dateRange[1] == null){
        message.error('Please select date range!!');
      }else{
        if (props.data){
          setChartLoading(true)
        }
        const fromDate = new Date(dateRange[0]);
        const fromyear = fromDate.getFullYear();
        const frommonth = String(fromDate.getMonth() + 1).padStart(2, '0');
        const fromday = String(fromDate.getDate()).padStart(2, '0');

        const fromFormattedDate = `${fromyear}-${frommonth}-${fromday}`;

        const toDate = new Date(dateRange[1]);
        const toyear = toDate.getFullYear();
        const tomonth = String(toDate.getMonth() + 1).padStart(2, '0');
        const today = String(toDate.getDate()).padStart(2, '0');

        const toFormattedDate = `${toyear}-${tomonth}-${today}`;
        props.action(props.selectedDevice.MAC,"CUSTOM",fromFormattedDate,toFormattedDate)
      }
    }
  }

  const [dateRange, setDateRange] = useState([null, null]);
  const [mode, setMode] = useState('1 WEEK')
  const [startDate, endDate] = dateRange;
  const chartRef = useRef(null);
  const defaultOptions = {
    textStyle: {
      color: "#000",
    },
    visualMap: [
      {
        show: false,
        type: "continuous",
        seriesIndex: 0,
        min: 80,
        max: 0,
      },
    ],
    title: [
      {
        left: "center",
      },
    ],
    tooltip: {
      trigger: "axis",
      axisPointer: {
      },
    },
    toolbox: {
      show: false,
      feature: {
        dataView: { readOnly: false },
        restore: {},
        saveAsImage: {},
      },
    },
    dataZoom: {
      show: false,
      start: 0,
      end: 100,
    },
    xAxis: [
      {
        axisLine: {
          show: false,
        },
        type: "category",
        boundaryGap: true,
        data: gen2STime(),
        splitLine: {
          show: false,
        },
      }
    ],
    yAxis: [
      {
        axisLine: {
          show: false,
        },
        type: "value",
        scale: true,
        max: 1,
        min: 0,
        boundaryGap: [0.2, 0.2],
        splitLine: {
          show: false,
        },
      }
    ],
    grid: [
      {
        bottom: "30%",
      },
    ],
    dataZoom: [
      {
        top: "80%",
        start: 0,
        end: 100,
        xAxisIndex: [0, 1],
        textStyle: {
          color: "#000"
        }
      },
    ],
    series: [
      {
        name: "Data Count",
        type: "bar",
        smooth: true,
        emphasis: {
          focus: "series",
        },
        data: randR(),
      }
    ],
  };
  const [option,setOption] = useState(defaultOptions)

  const onFinish = (values) => {
    console.log('Received values:', values);
    props.action(values);
  };

    const handleCustomDateChange = (update) => {
        setDateRange(update);

        if (update && update[0] && update[1]) {
            const fromDate = new Date(update[0]);
            const fromyear = fromDate.getFullYear();
            const frommonth = String(fromDate.getMonth() + 1).padStart(2, '0');
            const fromday = String(fromDate.getDate()).padStart(2, '0');
            const fromFormattedDate = `${fromyear}-${frommonth}-${fromday}`;

            const toDate = new Date(update[1]);
            const toyear = toDate.getFullYear();
            const tomonth = String(toDate.getMonth() + 1).padStart(2, '0');
            const today = String(toDate.getDate()).padStart(2, '0');
            const toFormattedDate = `${toyear}-${tomonth}-${today}`;

            if (props.selectedDevice && props.selectedDevice.MAC) {
                setChartLoading(true)
            }
            props.action(props.selectedDevice.MAC, "CUSTOM", fromFormattedDate, toFormattedDate)
        }
    }

    useEffect(() => {
        if (props.selectedDevice && props.selectedDevice.MAC) {
            console.log("Fetching device temperature for MAC:", props.selectedDevice.MAC);
            setChartLoading(true)
            props.action(props.selectedDevice.MAC, "1 HOUR")
        }
    }, [props.selectedDevice]);

    useEffect(() => {
  if (!props.data || !props.data.DATA || props.data.DATA.length === 0) {
    setOption({
      ...defaultOptions,
      yAxis: [
        {
          type: "value",
          scale: true,
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
      ],
      series: [
        {
          name: "Temperature",
          type: "line",
          smooth: true,
          data: [],
        },
      ],
    });

    setChartLoading(false);
    return;
  }

  const timeStart = Number(
    Array.isArray(props.data.TIME_START)
      ? props.data.TIME_START[0]
      : props.data.TIME_START
  );

  const values = String(props.data.DATA[0])
    .split(";")
    .filter((v) => v !== "")
    .map(Number);

    
  const times = values.map((_, index) => {
    const d = new Date((timeStart + index * 60) * 1000);

    return (
      d.getFullYear() +
      "-" +
      String(d.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(d.getDate()).padStart(2, "0") +
      " " +
      String(d.getHours()).padStart(2, "0") +
      ":" +
      String(d.getMinutes()).padStart(2, "0")
    );
  });

  console.log("Times:", times);
  console.log("Values:", values);

  setOption({
    ...defaultOptions,

    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        data: times,
        axisLine: {
          show: false,
        },
      },
    ],

    yAxis: [
      {
        type: "value",
        scale: true,
        axisLine: {
          show: false,
        },
        splitLine: {
          show: true,
        },
      },
    ],

    series: [
      {
        name: "Temperature",
        type: "line",
        smooth: true,
        showSymbol: false,
        data: values,
      },
    ],
  });

  setChartLoading(false);
}, [props.data]);

  return (
    <Modal
      title="Device Debug Information"
      open={props.visible}
      onOk={props.close}
      okText={t("Ok")}
      onCancel={props.close}
      width={700}
    >
      <Form
        form={form}
        onFinish={onFinish}
        initialValues={props.selectedDevice}
        layout="vertical"
      >
        <p>
          {t("DevicePage.deviceModal.macAddress")}:
          <span style={{ fontWeight: 'bold' }}>
            {props.selectedDevice ? props.selectedDevice.MAC : ''}
          </span>
        </p>
      </Form>

        <Card 
            title={t("DevicePage.table.temperature")}
            style={{ height: "100%"}} 
            className='content-card'
            extra={
                <Menu 
                style={{width:'100%'}}
                theme="light" 
                mode="horizontal"
                onClick={handleOption}
                defaultSelectedKeys={['1 HOUR']}
                >
                <Menu.Item key="1 HOUR">{t("location_history.hour")}</Menu.Item>
                <Menu.Item key="1 DAY">{t("location_history.day")}</Menu.Item>
                <Menu.Item key="1 WEEK">{t("location_history.week")}</Menu.Item>
                <Menu.Item key="1 MONTH">{t("location_history.month")}</Menu.Item>
                <Menu.Item key="CUSTOM">{t("location_history.custom")}</Menu.Item>
                </Menu>
            }
            >
            <Row>
                <Col span={24}>
                {showCustomPicker && (
                    <div style={{ marginBottom: 12, padding: 12, border: '1px solid #d9d9d9', borderRadius: 8, background: '#fff' }}>
                        <DatePicker
                            selectsRange={true}
                            startDate={startDate}
                            endDate={endDate}
                            onChange={handleCustomDateChange}
                            isClearable={true}
                        />
                    </div>
                )}
                <ReactECharts
  ref={chartRef}
  option={option}
  style={{ height: 400, width: 500 }}
  notMerge={true}
  lazyUpdate={false}
/>
                </Col>
            </Row>
            {
                chartLoading && <ChartLoader/>
            }
            </Card>

    </Modal>
  );
};

export default DeviceDebugModal;